var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[(_vm.picture)?_c('img',{class:_vm.$style.avatarImage,attrs:{"src":_vm.picture,"alt":""}}):_c('div',{class:_vm.$style.initialsWrapper},[_c('div',{class:[_vm.$style.initialsLabel, ( _obj = {}, _obj[_vm.$style.initialsLabelStyleSmall] = _vm.small, _obj )]},[_vm._v(_vm._s(_vm.initials))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b5ac9d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","vector":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Avatar.vue
// module id = L7KG
// module chunks = 0